import { render } from "./WhatsAppIcon.vue?vue&type=template&id=4b5b08e0&scoped=true"
import script from "./WhatsAppIcon.vue?vue&type=script&lang=js"
export * from "./WhatsAppIcon.vue?vue&type=script&lang=js"

import "./WhatsAppIcon.vue?vue&type=style&index=0&id=4b5b08e0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b5b08e0"]])

export default __exports__